export default __webpack_public_path__ + "static/media/cmft android.614f6644.png";